import { render, staticRenderFns } from "./GermanforBeginners.vue?vue&type=template&id=707ae9ee&scoped=true&"
import script from "./GermanforBeginners.vue?vue&type=script&lang=js&"
export * from "./GermanforBeginners.vue?vue&type=script&lang=js&"
import style0 from "@/assets/hometeacher/css/main.css?vue&type=style&index=0&lang=css&"
import style1 from "./GermanforBeginners.vue?vue&type=style&index=1&id=707ae9ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707ae9ee",
  null
  
)

export default component.exports